export default __webpack_public_path__ + "static/media/Logo.40f1e2ad.svg";